module.exports = __webpack_public_path__ + "media/hallBgm.ac6c4c0d.mp3";